export const texts = {
  title: {
    de: 'Kostenfreie Analyse anfordern',
    en: 'Request a free analysis'
  },
  body: {
    de: 'Wir erstellen für dich eine kostenfreie Analyse: Wie groß ist die Zielgruppe? Welche Anforderungen schränken ein? Wie kannst du mehr Talente erreichen? Du erhältst die Ergebnisse innerhalb von 24 Stunden.',
    en: 'We create a free analysis for you: How large is the target group? Which requirements are limiting? How can you reach more talents? You will receive the results within 24 hours.'
  },
  commentLabel: {
    de: 'Deine Anmerkungen',
    en: 'Your notes'
  },
  commentPlaceholder: {
    de: 'Optional, z.B. Hinweise oder Links zu Referenzprofilen',
    en: 'Optional, e.g. notes or links to reference profiles'
  },
  cancel: {
    de: 'Abbrechen',
    en: 'Cancel'
  },
  requestAnalysis: {
    de: 'Analyse anfordern',
    en: 'Request analysis'
  },
  thankYou: {
    de: 'Vielen Dank!',
    en: 'Thank you!'
  },
  confirmation: {
    de: 'Deine Analyse wurde angefordert. Du erhältst die Ergebnisse innerhalb von 24 Stunden.',
    en: 'Your analysis has been requested. You will receive the results within 24 hours.'
  },
  close: {
    de: 'Schließen',
    en: 'Close'
  }
};
